import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';
import { Router } from '../../../node_modules/@angular/router';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss']
})
export class AgentsComponent implements OnInit {

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService,
    public router: Router
  ) { }

  ngOnInit() {
    if (!this.dataSvc.hasChosen) {
      this.router.navigateByUrl("/");
    }
  }



}
